import { music24NoLicense } from 'fym-common/src/license/music24NoLicense';
import { Music24LicenseStateType } from 'fym-common/src/license/music24Types';

export const LicenseState: Music24LicenseStateType = music24NoLicense;
